"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReceipt = exports.createReceipt = exports.getReceipt = void 0;
const shared_1 = require("@getgreenline/shared");
const getReceipt = (companyId, locationId) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.get(`/api/v1/companies/${companyId}/locations/${locationId}/receipt`);
    return res.data || undefined;
});
exports.getReceipt = getReceipt;
const createReceipt = (companyId, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.post(`/api/v1/companies/${companyId}/locations/${payload.locationId}/receipt`, payload);
    return res.data;
});
exports.createReceipt = createReceipt;
const updateReceipt = (companyId, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield shared_1.axios.put(`/api/v1/companies/${companyId}/locations/${payload.locationId}/receipt/${payload.id}`, payload);
    return res.data;
});
exports.updateReceipt = updateReceipt;
//# sourceMappingURL=receiptApi.js.map